var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "categoryProducts" },
    [
      _c(
        "div",
        { staticClass: "categoryProducts-title" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "20%" },
              attrs: { filterable: "", placeholder: "请选择集配中心" },
              on: { change: _vm.logisticchange },
              model: {
                value: _vm.logistic_business_id,
                callback: function ($$v) {
                  _vm.logistic_business_id = $$v
                },
                expression: "logistic_business_id",
              },
            },
            _vm._l(_vm.options, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "categoryProducts-cnt" }, [
        _c(
          "div",
          { staticClass: "categoryProducts-cnt-left" },
          [
            _c(
              "div",
              { staticClass: "mb-10 d-flex a-center" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      remote: "",
                      placeholder: "请输入",
                      "remote-method": _vm.remoteMethod,
                      loading: _vm.loadingSearch,
                      clearable: "",
                    },
                    on: {
                      "visible-change": _vm.onChangeVisible,
                      change: _vm.change,
                    },
                    model: {
                      value: _vm.key,
                      callback: function ($$v) {
                        _vm.key = $$v
                      },
                      expression: "key",
                    },
                  },
                  [
                    _c(
                      "div",
                      _vm._l(_vm.cateSearchList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label: `${item.p_name}-${item.name}`,
                            value: item.id,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("el-tree", {
              ref: "tree",
              attrs: {
                data: _vm.treeData,
                props: _vm.defaultProps,
                "node-key": "id",
                "highlight-current": false,
              },
              on: { "node-click": _vm.handleNodeClick },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ node, data }) {
                    return _c(
                      "span",
                      {
                        class:
                          (node.level == 1 &&
                            _vm.currentHighlightLevel1 == data.id) ||
                          (node.level == 2 &&
                            _vm.currentSelectedLevel2 == data.id)
                            ? "cateBg"
                            : "",
                      },
                      [_vm._v(" " + _vm._s(node.label) + " ")]
                    )
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "categoryProducts-cnt-right" },
          [
            _c("Filtersearch", {
              ref: "Filtersearchref",
              attrs: { list: _vm.Filtersearchlist, fromdata: _vm.formData },
              on: { Refresh: _vm.onHandleRefresh, search: _vm.onSearch },
              scopedSlots: _vm._u(
                [
                  _vm.currentSelectedLevel2
                    ? {
                        key: "left",
                        fn: function () {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.KeyAttributes },
                              },
                              [_vm._v("关键属性")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.openConfigProperties },
                              },
                              [_vm._v("配置属性")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.openBatchSit },
                              },
                              [_vm._v("批量设置坑位")]
                            ),
                          ]
                        },
                        proxy: true,
                      }
                    : null,
                ],
                null,
                true
              ),
            }),
            _c(
              "div",
              { staticClass: "auto-table-flex" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "table",
                    attrs: {
                      data: _vm.tableData,
                      height: "100%",
                      border: true,
                      "header-cell-style": {
                        color: "#333333",
                        background: "#EFF6FF",
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        width: "100px",
                        align: "center",
                        label: "序号",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        align: "center",
                        label: "品类名称",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "slot", align: "center", label: "坑位" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "name", align: "center", label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.ProductCategory(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("商品审核")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openSetThreePit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("设置坑位")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("batchSetPit", {
        ref: "batchSetPitRef",
        on: { submit: _vm.getdownconfiglist },
      }),
      _c("configProperties", { ref: "configPropertiesRef" }),
      _c("setThreePit", {
        ref: "setThreePitRef",
        on: { submit: _vm.getdownconfiglist },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }